import { User } from "../types"
import { getUserTypeMapping } from "../types-helpers"

export const sortUsers = (a: User, b: User): number => {
    if (a.userType != b.userType) {
        return getUserTypeMapping(b.userType) - getUserTypeMapping(a.userType)
    }

    return a.fullName.localeCompare(b.fullName)
}